import { useEffect, useRef } from 'react';
import { ProductTransferListResponseDto } from '@tiendanube/common';

const REFRESH_INTERVAL = 5000; // 5 seconds

interface UseTransferAutoRefreshProps {
  data: ProductTransferListResponseDto[number][];
  refetch: () => void;
}

export function useTransfersAutoRefresh({
  data,
  refetch,
}: UseTransferAutoRefreshProps) {
  const intervalRef = useRef<NodeJS.Timeout | null>(null);

  // Detect if there are pending transfers and configure automatic refresh
  useEffect(() => {
    const hasPendingTransfers = data?.some(
      (transfer) => transfer.status === 'pending',
    );

    if (hasPendingTransfers && refetch) {
      // Clean previous interval if it exists
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
        intervalRef.current = null;
      }

      // Configure new interval
      intervalRef.current = setInterval(() => {
        refetch();
      }, REFRESH_INTERVAL);
    } else {
      // Clean interval if there are no pending transfers
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
        intervalRef.current = null;
      }
    }

    // Cleanup when unmounting the component
    return () => {
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
        intervalRef.current = null;
      }
    };
  }, [data, refetch]);
}
